import React from 'react';
import logoImage from '@public/images/index/img-0.png';

function SiteHeader({ activeView, onChangeView }) {
  return (
    <header className="site-header" id="page-switcher">
      <div className="container header-inner">
        <div className="logo">
          <img src={logoImage} alt="中邮保险资产管理有限公司" />
        </div>
        <nav className="top-tabs" role="tablist" aria-label="招聘页面">
          <button
            className={`top-tab${activeView === 'notice-view' ? ' active' : ''}`}
            type="button"
            role="tab"
            aria-selected={activeView === 'notice-view'}
            aria-controls="notice-view"
            onClick={() => onChangeView('notice-view')}
          >
            招聘公告
          </button>
          <button
            className={`top-tab${activeView === 'jobs-view' ? ' active' : ''}`}
            type="button"
            role="tab"
            aria-selected={activeView === 'jobs-view'}
            aria-controls="jobs-view"
            onClick={() => onChangeView('jobs-view')}
          >
            招聘岗位
          </button>
        </nav>
      </div>
    </header>
  );
}

export default SiteHeader;
